// extracted by mini-css-extract-plugin
module.exports = {"icon-underline-arrow":"SingleDatasheet-module__icon-underline-arrow___1FkOc"};